import React, { useEffect, useState, Fragment } from 'react'
import { useHistory, Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PalexLogo from './PalexLogo'
import PalexLogoDark from './PalexLogoNegro'
import { routes } from '../../constantes/routes'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { FiMenu } from '@react-icons/all-files/fi/FiMenu'
import { IoIosArrowDown } from '@react-icons/all-files/io/IoIosArrowDown'
import { authApi } from '../../api/authApi'
import 'semantic-ui-css/components/dropdown.css'
import '../../assests/styles/header/navbar.scss'

const NavbarApp = () => {
  const history = useHistory()
  const location = useLocation()

  const userProfile = useSelector((state) => state.userProfile)
  const dispatch = useDispatch()
  const logout = () => dispatch(authApi.logout())

  const [username, setUsername] = useState('')
  const [idUser, setIdUser] = useState('')

  useEffect(() => {
    setUsername(userProfile.nombre)
    setIdUser(userProfile.id_Usuario)
  }, [userProfile])

  const logOut = async () => {
    await logout()
    history.push(routes.LANDING)
  }

  const myProfile = () => {
    history.push(routes.PROFILE + idUser)
  }

  const user = (
    <Fragment>
      <span>
        {username}
        <IoIosArrowDown role='button' type='button' data-toggle='dropdown' />
      </span>
    </Fragment>
  )

  return (
    <Navbar collapseOnSelect={true} expand='sm' variant='dark'>
      {userProfile?.id_TipoColor === 1 ? <PalexLogo /> : <PalexLogoDark />}
      <Navbar.Toggle aria-controls='responsive-navbar-nav'>
        <FiMenu className='custom-toggler' />
      </Navbar.Toggle>
      <Navbar.Collapse id='responsive-navbar-nav'>
        <Nav className='mr-auto'></Nav>
        <Nav>
          <Nav.Link eventKey='1' as={Link} to='/main'>
            Home
          </Nav.Link>
          {userProfile.roles.isBackofficeVer ? (
            <Nav.Link eventKey='2' as={Link} to={routes.BACKOFFICE}>
              Backoffice
            </Nav.Link>
          ) : null}
          <Nav.Link eventKey='3' as={Link} to={routes.CONTACTS}>
            Contactos
          </Nav.Link>
          <Nav.Link eventKey='4' as={Link} to={routes.CONTACT_NEW}>
            Nuevo contacto
          </Nav.Link>
          <Nav.Link eventKey='5' as={Link} to={routes.CALENDAR}>
            Agenda
          </Nav.Link>
          <NavDropdown title={user} id='collasible-nav-dropdown'>
            <NavDropdown.Item eventKey='6' onClick={myProfile}>
              Perfil
            </NavDropdown.Item>
            <NavDropdown.Item eventKey='8' onClick={logOut}>
              Cerrar sesión
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavbarApp
